import {
  UNASSIGNED_PANEL_PART,
  SMART_SWITCH,
} from 'components/SwitchAndGauge/definitions/dashConstants'
import { curry } from 'ramda'

const doesParentExistRule = {
  name: 'doesParentExistRule',
  rule: curry(({ components }, __, location) =>
    Boolean(components[location.parent])
  ),
}

const unassignedSmartSwitchRule = {
  name: 'unassignedSmartSwitchRule',
  rule: curry(({ components }, __, location) => {
    const isEmptyLocation = !components[location?.name]
    const isPlug =
      !isEmptyLocation &&
      components[location?.name].panelDescription.toUpperCase().includes('PLUG')

    return isPlug || isEmptyLocation
  }),
}

const uassignedPanelPartRule = {
  name: 'uassignedPanelPartRule',
  rule: curry(({ components }, __, location) => {
    const isEmptyLocation = !components[location?.name]

    return isEmptyLocation
  }),
}

export const rules = {
  defaults: [doesParentExistRule],
  [`${UNASSIGNED_PANEL_PART}--${SMART_SWITCH}`]: [
    unassignedSmartSwitchRule,
    doesParentExistRule,
  ],
  [UNASSIGNED_PANEL_PART]: [uassignedPanelPartRule, doesParentExistRule],
}
